import { Button, Modal } from '@getro/rombo';
import { Code, SquareCheckBig, Pointer } from 'lucide-react';
import React, { useState } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';

import { UserNetworkLogo } from 'components/organisms/contactActionPanel/userNetworkLogo';
import ContactsSharedListSchema from '../../../schemas/contactsSharedList';

const HowItWorks = ({ listInfo, ...otherProps }) => {
  const [showHowItWorks, setShowHowItWorks] = useState(false);

  const items = [
    {
      icon: SquareCheckBig,
      title: 'Select one or more contacts you’d like an intro to',
    },
    {
      icon: Pointer,
      title: 'Click the “Request intros” button',
    },
    {
      icon: Code,
      title: `${listInfo.introRequestManager?.fullName} will be notified and will follow-up`,
    },
  ];

  return (
    <>
      <Text
        fontSize="14px"
        color="text.main"
        sx={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={() => setShowHowItWorks(true)}
        data-testid="how-it-works-trigger"
      >
        How does this work?
      </Text>
      <Box {...otherProps}>
        {showHowItWorks && (
          <Modal isOpen={showHowItWorks} onCancel={() => setShowHowItWorks(false)}>
            <Flex sx={{ flexDirection: 'column', gap: '24px' }}>
              <Flex sx={{ gap: '24px', lineHeight: '140%', alignItems: 'center' }}>
                <UserNetworkLogo
                  network={listInfo.collection}
                  user={listInfo.introRequestManager}
                  width="48px"
                  height="48px"
                />
              </Flex>
              <Text sx={{ lineHeight: '140% !important', fontSize: '18px', fontWeight: '600', color: 'text.dark' }}>
                {listInfo.introRequestManager?.fullName} from {listInfo.collection?.name} is offering intros to these
                contacts
              </Text>
              <Flex sx={{ flexDirection: 'column', gap: '16px' }}>
                {items.map((item) => (
                  <Flex key={item.title} sx={{ alignItems: 'center', gap: '8px' }}>
                    <Flex
                      bg="purple.100"
                      color="purple.500"
                      height="32px"
                      width="32px"
                      flex="0 0 auto"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ borderRadius: 'circle' }}
                    >
                      <Box as={item.icon} width="16px" height="16px" aria-hidden="true" />
                    </Flex>
                    <Box flexGrow="1">
                      <Text fontWeight="medium" color="text.dark" fontSize="14px">
                        {item.title}
                      </Text>
                    </Box>
                  </Flex>
                ))}
              </Flex>
              <Flex justifyContent="flex-end">
                <Button width="100%" justifyContent="center" onClick={() => setShowHowItWorks(false)}>
                  Got it
                </Button>
              </Flex>
            </Flex>
          </Modal>
        )}
      </Box>
    </>
  );
};

HowItWorks.propTypes = {
  listInfo: ContactsSharedListSchema.isRequired,
};

export default HowItWorks;
